var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 34,
    viewBox: "0 0 14 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 11C1.6 10.6686 1.33137 10.4 1 10.4C0.668629 10.4 0.4 10.6686 0.4 11H1.6ZM1 23H0.4C0.4 23.3314 0.668629 23.6 1 23.6L1 23ZM13.4243 23.4243C13.6586 23.1899 13.6586 22.8101 13.4243 22.5757L9.60589 18.7574C9.37157 18.523 8.99167 18.523 8.75736 18.7574C8.52305 18.9917 8.52305 19.3716 8.75736 19.6059L12.1515 23L8.75736 26.3941C8.52305 26.6284 8.52305 27.0083 8.75736 27.2426C8.99167 27.477 9.37157 27.477 9.60589 27.2426L13.4243 23.4243ZM0.4 11V23H1.6V11H0.4ZM1 23.6H13V22.4H1V23.6Z",
    fill: "#B4BAC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoComment);
export default __webpack_public_path__ + "static/media/ico-comment.f21fcb6c9b6c18fd3bfb721052689661.svg";
export { ForwardRef as ReactComponent };